import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import {VehicleAdminRow} from '../../../_models/vehicle';
import {TrackerService} from '../../../_services/trackers.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import { PaginationParams } from '../../../_models/generic';

export class TrackerDataSource implements DataSource<VehicleAdminRow> {

    private vehiclesSubject = new BehaviorSubject<VehicleAdminRow[]>([]);

    private loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this.loadingSubject.asObservable();
    public paginatorTotalCount: number;

    constructor(private vehicleService: TrackerService) {

    }

    loadAdminVehicles(params: PaginationParams) {
        this.loadingSubject.next(true);

        this.vehicleService.findTrackersMultiSelect(params).pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe(vehicles => {
                console.log('trackers service in Datasource: ', vehicles);
                this.paginatorTotalCount = vehicles['count'];
                this.vehiclesSubject.next(vehicles['results']);
            });

    }

    connect(collectionViewer: CollectionViewer): Observable<VehicleAdminRow[]> {
        console.log("Connecting Vehicles Admin data source");
        return this.vehiclesSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.vehiclesSubject.complete();
        this.loadingSubject.complete();
    }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-trackers/trackers.datasource.ts